module.exports = __webpack_public_path__ + "static/media/video.53a77e03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/Harvey/video.jpg
// module id = 302
// module chunks = 0